module.exports = __webpack_public_path__ + "img/igape-off.bbb6d02f.png";